import { useTranslation } from "react-i18next";
import TopTemples from "../common/topTemples";
import IndiaMap from "../common/indiaMap";
import StackedChart from "../common/stackedChart";
import GraphChart from "../common/graphChart";
import YearRankingTable from "../common/yearRankingTable";
import BooksPledgeTable from "../common/booksPledgeTable";
import StateWisePointsTable from "../common/stateWisePointsTable";

const TempleDashboard = ({
  selectedEvent,
  userBooksStatsData,
  overAllPointsCount,
  userEventRanking,
  previousYearUserEventRanking,
  topTemplesList,
  monthlyPoints,
  user,
  yearlyPoints,
}) => {
  const { t, i18n } = useTranslation();

  console.log("monthly", monthlyPoints);
  console.log("yearly", yearlyPoints);

  return (
    <>
      <div className="row mt-4">
        <div
          className={
            selectedEvent == "Regular Update" ||
            selectedEvent == "Gita Marathon"
              ? "col-md-8"
              : "col-md-4"
          }
        >
          <GraphChart
            booksData={monthlyPoints}
            graphHeader={t("Harinaam Sankirtan Monthly Score")}
            type={"monthly"}
            selectedEvent={selectedEvent}
          />
        </div>
        <div className="col-md-4 graph-stats-div">
          <GraphChart
            booksData={yearlyPoints}
            graphHeader={t("Year Wise Score")}
            type="yearly"
          />
        </div>
      </div>
      <div className="row mt-2 temple-login" id="state-wise-points">
        <div className="col-md-6">
          <TopTemples
            topTemplesList={topTemplesList}
            user={user}
            isGBCUser={false}
            eventWiseCard={true}
            selectedEvent={selectedEvent}
            showFullCard={true}
          />
        </div>
        <div className="col-md-6 mt-2">
          <IndiaMap selectedEvent={selectedEvent} />
        </div>
      </div>
    </>
  );
};

export default TempleDashboard;
